module.exports = __webpack_public_path__ + "img/brand-right.95d1f10e.png";